export default __webpack_public_path__ + "static/amazonFires3-17a664d6f321e50d5915d81b22ffda82.gif";